'use strict';

{
  //外部リンク
  const links = document.querySelectorAll('a');
  for (let i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noopener';
    }
  }

  // 告知バー表示判定
  const announcementBar = document.querySelector('.announcement-bar-section');
  if (announcementBar) {
    document.body.classList.add('announcement-bar-true');
  }

  // ページ先頭に戻るボタン
  const pageTopButton = document.querySelector('.page-top');
  if (pageTopButton) {
    const pageTopButtonAnchor = pageTopButton.querySelector('a');

    const handleScroll = () => {
      if (window.scrollY >= 144) {
        pageTopButton.classList.add('active');
      } else {
        pageTopButton.classList.remove('active');
      }
    };

    const handleFocus = () => pageTopButton.classList.add('active');
    const handleBlur = () => pageTopButton.classList.remove('active');

    window.addEventListener('scroll', handleScroll);
    pageTopButtonAnchor.addEventListener('focus', handleFocus);
    pageTopButtonAnchor.addEventListener('blur', handleBlur);
  }

  //nav
  const nav = document.querySelector('nav');
  const el = document.querySelectorAll('details[id^="Details-HeaderMenu-"]');
  el.forEach((item) => {
    const summary = item.querySelector('summary');
    // マウスホバー時の挙動
    item.addEventListener('mouseenter', () => {
      item.setAttribute('open', '');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    });

    item.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  });
}
